/**
 * Choose how the viewer loads a garment. A recipe URL stands alone:
 * it cannot be combined with a mockup id or style lookup fields.
 */
export function resolveViewerLoad(input) {
    const brand = input.brand.trim();
    const styleNumber = input.styleNumber.trim();
    const colorway = input.colorway.trim();
    const mockupId = input.mockupId.trim();
    const recipeUrl = input.recipeUrl.trim();
    if (recipeUrl) {
        if (mockupId || brand || styleNumber || colorway) {
            return {
                ok: false,
                message: '"recipe_url" cannot be combined with "mockup_id", "brand", "style_number", or "colorway".',
            };
        }
        return { ok: true, mode: 'recipe', recipeUrl };
    }
    if (mockupId) {
        return { ok: true, mode: 'mockup', mockupId };
    }
    if (!brand || !styleNumber || !colorway) {
        return {
            ok: false,
            message: 'Missing required query parameters "brand", "style_number" and/or "colorway".',
        };
    }
    return { ok: true, mode: 'style', brand, styleNumber, colorway };
}
